module.exports = __webpack_public_path__ + "img/PointsBackgroun.aa1c832d.png";